import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useRecoilState } from "recoil";
import styled from "styled-components";
import { BackButton } from "../../components/BackButton";
import { langState, langText } from "../../recoil/lang";

const testData: any = [
  {
    storeName: "호랑이반점호랑이반점호랑이반점호랑이반점호랑이반점호랑이반점",
    orderTime: "2023/11/16 19:00",
    telNumber: "010-1234-1234",
  },
  {
    storeName: "몽몽치킨",
    orderTime: "2023/11/18 12:34",
    telNumber: "02-124-1564",
  },
  {
    storeName: "노크호텔 직영점",
    orderTime: "2023/11/18 14:20",
    telNumber: "02-1234-1114",
  },
  {
    storeName: "노크호텔 직영점",
    orderTime: "2023/11/19 17:45",
    telNumber: "02-1234-1114",
  },
  {
    storeName: "명품족발",
    orderTime: "2023/11/21 11:00",
    telNumber: "010-0999-9990",
  },
  {
    storeName: "호랑이반점",
    orderTime: "2023/11/16 19:00",
    telNumber: "010-1234-1234",
  },
  {
    storeName: "몽몽치킨",
    orderTime: "2023/11/18 12:34",
    telNumber: "02-124-1564",
  },
  {
    storeName: "노크호텔 직영점",
    orderTime: "2023/11/18 14:20",
    telNumber: "02-1234-1114",
  },
  {
    storeName: "노크호텔 직영점",
    orderTime: "2023/11/19 17:45",
    telNumber: "02-1234-1114",
  },
  {
    storeName: "명품족발",
    orderTime: "2023/11/21 11:00",
    telNumber: "010-0999-9990",
  },
  {
    storeName: "호랑이반점",
    orderTime: "2023/11/16 19:00",
    telNumber: "010-1234-1234",
  },
  {
    storeName: "몽몽치킨",
    orderTime: "2023/11/18 12:34",
    telNumber: "02-124-1564",
  },
  {
    storeName: "노크호텔 직영점",
    orderTime: "2023/11/18 14:20",
    telNumber: "02-1234-1114",
  },
  {
    storeName: "노크호텔 직영점",
    orderTime: "2023/11/19 17:45",
    telNumber: "02-1234-1114",
  },
  {
    storeName: "명품족발",
    orderTime: "2023/11/21 11:00",
    telNumber: "010-0999-9990",
  },
];

const OrderHistory = () => {
  const id = useParams();
  const navigate = useNavigate();

  const [lang, setLang] = useRecoilState<number>(langState);

  const navigateHome = () => {
    navigate(`/`);
  };
  const navigateMaster = () => {
    navigate(`/master`);
  };

  const RenderHistoryItem = () => {
    return testData.length > 0 ? (
      <div className="listWrap">
        {testData.map((item: any, index: number) => {
          return (
            <div key={index} className="row">
              <div className="orderIndex">
                <div className="indexBox">{index + 1}</div>
              </div>
              <div className="orderDate">{item.orderTime}</div>
              <div className="orderStore">{item.storeName}</div>
              <div className="orderStoreTel">{item.telNumber}</div>
            </div>
          );
        })}
      </div>
    ) : (
      <div className="noneWrap">
        <h1>{langText.orderHistory_nothing[lang]}</h1>
      </div>
    );
  };

  return (
    <Style>
      <div className="knockContainer">
        <div className="header">
          <BackButton pathname="orderHistory" />
        </div>
        <div className="content">
          <h1>{langText.orderHistory_title[lang]}</h1>
          <RenderHistoryItem />
        </div>
        <div className="bottomButtonWrap">
          <button className="homeButton" onClick={navigateHome}>
            {langText.button_home[lang]}
          </button>
        </div>
      </div>
    </Style>
  );
};
export default OrderHistory;

const Style = styled.div`
  .knockContainer {
    min-height: 100vh;
    height: 100%;
    background: #000000;
    display: flex;
    flex-direction: column;
  }
  .backButton {
    position: absolute;
    left: 0;
  }
  .buttonWrap {
    position: absolute;
    right: 0;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .historyButton {
    padding: 3px 12px;
    border-radius: 50px;
    border: 1px solid #555555;
    background: #262626;
    display: flex;
    align-items: center;
    cursor: pointer;
  }
  .languageButton {
    padding: 2px 18px;
    border-radius: 50px;
    border: 1px solid #555555;
    background: #262626;
    display: flex;
    align-items: center;
    color: #ffffff;
    font-size: 16px;
    line-height: 24px;
    font-weight: 200;
    gap: 8px;
    cursor: pointer;
  }

  .row {
    display: flex;
    align-items: center;
  }
  .header {
    padding-top: 20px;
    height: 8vh;
    margin-left: 4%;
    margin-right: 4%;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    position: relative;
  }
  .content {
    height: 80vh;
    padding-left: 4%;
    padding-right: 4%;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    position: relative;

    h1 {
      font-size: 34px;
      line-height: 46px;
      font-weight: 300;
      color: #ffffff;
    }
  }
  .row.gap4 {
    gap: 4px;
  }
  .row.gap8 {
    gap: 8px;
  }
  .titleFont {
    font-size: 24px;
    line-height: 28px;
    font-weight: 200;
    margin: 0 0;
    color: #ffffff;
  }
  .row.underGap10 {
    padding-bottom: 10px;
  }

  .row.underGap30 {
    padding-bottom: 30px;
  }
  .row.underGap50 {
    padding-bottom: 50px;
  }

  h3 {
    font-size: 20px;
    line-height: 28px;
    color: #ffffff;
    font-weight: 200;
    padding-bottom: 8px;
    margin: 0 0;
  }

  .noneWrap {
    width: 100%;
    height: 85%;
    background: #000000;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    h1 {
      font-size: 36px;
      line-height: 46px;
      font-weight: 600;
      color: #555555;
    }
  }

  .listWrap {
    width: 100%;
    height: 88%;
    overflow-y: auto;
    margin-top: 6%;
    padding: 30px 30px;
    background: #2b2b2b;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    gap: 40px;

    .orderIndex {
      flex: 1;
      .indexBox {
        width: 24px;
        height: 24px;
        border-radius: 4px;
        border: 1px solid #555555;
        background: #262626;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        line-height: 16px;
        color: #ffffff;
        font-weight: 300;
        margin: 0 0;
      }
    }

    .orderDate {
      flex: 5;
      font-size: 18px;
      line-height: 24px;
      color: #ffffff;
      font-weight: 300;
      margin: 0 0;
      text-align: left;
    }

    .orderStore {
      flex: 6;
      font-size: 18px;
      line-height: 24px;
      color: #ffffff;
      font-weight: 300;
      margin: 0 0;
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding: 0 20px;
    }
    .orderStoreTel {
      flex: 4;
      font-size: 18px;
      line-height: 24px;
      color: #ffffff;
      font-weight: 300;
      margin: 0 0;
      text-align: left;
    }
  }
  .bottomButtonWrap {
    width: 100%;
    height: 12vh;
    padding: 3% 4%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .homeButton {
    width: 100%;
    padding: 12px 0;
    background: #ffffff;
    border: 2px solid #ffffff;
    border-radius: 10px;
    color: "#000000";
    font-size: 20px;
    line-height: 30px;
    font-weight: 600;
    cursor: pointer;
  }
`;
